import { render, staticRenderFns } from "./ReadOnlyTable.vue?vue&type=template&id=2c953086&scoped=true&"
import script from "./ReadOnlyTable.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c953086",
  null
  
)

export default component.exports